<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showApplicant"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="change-height fixed center-h-v bg-white h-4/5 overflow-auto rounded-md shadow-2xl sm:w-3/5 w-full"
        >
          <!-- top bar -->
          <div class="flex justify-between items-center border-b-1.5 p-3 sticky top-0 bg-white">
            <p class="text-base">John Doe</p>
            <img
              v-if="!loading"
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <div class="grid lg:grid-cols-3 divide-x-1.5 lg:mb-10">
            <div class="h-full w-full col-span-1">
              <div class="lg:p-7 p-4 grid grid-cols-2 lg:grid-cols-1">
                <div>
                  <img
                    class="h-20 w-20 rounded-full mx-auto mb-5"
                    src="https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png"
                  />
                </div>
                <div class="w-max">
                  <p class="font-medium text-xl">John Doe</p>
                  <p>Sales Manager</p>
                  <p>Step: First Interview</p>
                  <p>Reviewer: Maxwell Doe</p>
                  <div class="font-bold flex-col my-3 flex gap-2">
                    <p>
                      <span>&#9993; </span>
                      <a href="mailto:johh@gmail.com">johh@gmail.com</a>
                    </p>
                    <p>
                      <span>&#9742; </span>
                      <a href="tel:0700333333">0700333333</a>
                    </p>
                  </div>

                  <select
                    v-model="selectedStep"
                    class="p-2 bg-primary text-white rounded-md my-3"
                  >
                    <option
                      v-for="step in steps"
                      :key="step"
                      class="bg-white text-black"
                    >
                      {{ step }}
                    </option>
                  </select>
                  <p>Date Applied: Aprill 05 2022</p>
                  <p>From: Linkedin</p>
                </div>
              </div>
            </div>
            <div class="h-full w-full col-span-2">
              <div>
                <div class="flex justify-evenly border-b-1.5">
                  <div
                    @click="changeTab(tab)"
                    class="w-full text-center p-3 cursor-pointer hover:bg-primary hover:text-white"
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :class="selectedTab == tab ? 'bg-primary text-white' : ''"
                  >
                    {{ tab }}
                  </div>
                </div>
                <profile v-if="selectedTab == 'Profile'" :key="pKey"></profile>
                <evaluation
                  v-if="selectedTab == 'Evaluation'"
                  :key="eKey"
                ></evaluation>
                <activity
                  v-if="selectedTab == 'Activity'"
                  :key="aKey"
                ></activity>
              </div>
            </div>
          </div>

          <!-- show offer -->
          <offer :showOffer="showOffer" @close="handleOfferClose"></offer>

          <!-- New profile -->
          <new-profile
            :showNewProfile="showNewProfile"
            @close="handleNewProfileClose"
          ></new-profile>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Activity from "./onboardingTabs/activity.vue";
import Profile from "./onboardingTabs/profile.vue";
import Evaluation from "./onboardingTabs/evaluation.vue";
import Offer from "./offer.vue";
import NewProfile from "./newProfile.vue";
export default {
  name: "Applicant",
  props: ["showApplicant"],
  components: { Activity, Profile, Evaluation, Offer, NewProfile },
  data() {
    return {
      tabs: ["Profile", "Evaluation", "Activity"],
      steps: ["Move To", "Screening", "Interview", "Offered", "Hired"],
      selectedStep: "Move To",
      selectedTab: "Profile",
      showOffer: false,
      showNewProfile: false,
      showMoveToOffer: false,
      offerTabs: ["Job Information", "Checklist"],
      pKey: 0,
      eKey: 1,
      aKey: 2,
    };
  },
  watch: {
    selectedStep: function (val) {
      if (val == "Offered") {
        this.showOffer = true;
      } else if (val == "Hired") {
        this.showNewProfile = true;
      }
    },
  },
  methods: {
    handleOfferClose() {
      this.showOffer = false;
    },
    handleNewProfileClose() {
      this.showNewProfile = false;
    },
    close() {
      this.$emit("close");
    },
    changeTab(tab) {
      this.selectedTab = tab;
      switch (tab) {
        case "Profile":
          this.pKey++;
          break;
        case "Evaluation":
          this.eKey++;
          break;
        case "Activity":
          this.aKey++;
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
.change-height {
  transition: height 0.15s ease-out;
}
</style>
